module.exports = __webpack_public_path__ + "static/table-720e16ae4c6b985ccfb6eeb381cd919b.png";